export const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_visual-spectacle/artifacts/jxzbadzx_TVS%20Transparent%20Logo%20png.png";

export const SERVICES = [
  {
    id: "lighting-consultant",
    index: "01",
    title: "Lighting Consultant",
    icon: "Lightbulb",
    blurb:
      "Strategic direction from the first sketch — venue analysis, mood language and technical feasibility before a single fixture is hung.",
  },
  {
    id: "lighting-design",
    index: "02",
    title: "Lighting Design",
    icon: "Sparkles",
    blurb:
      "Emotion engineered in lumens. We paint architecture, artists and audiences with intent, colour and rhythm.",
  },
  {
    id: "stage-design",
    index: "03",
    title: "Stage Design",
    icon: "LayoutPanelTop",
    blurb:
      "Sculptural sets and immersive scenography that turn an empty floor into a world the moment the doors open.",
  },
  {
    id: "plot-stage",
    index: "04",
    title: "Lighting Plot & Stage Design",
    icon: "Grid3x3",
    blurb:
      "Precision plots married to scenic form — every beam, truss and sightline resolved on paper before load-in.",
  },
  {
    id: "rigging",
    index: "05",
    title: "Rigging Plots & Layout",
    icon: "Anchor",
    blurb:
      "Load-safe rigging schemes and hang plots engineered for the venue, the crew and the clock.",
  },
  {
    id: "lighting-designers",
    index: "06",
    title: "Lighting Designers",
    icon: "PenTool",
    blurb:
      "A collective of designers who live between the console and the concept — available to lead or embed with your team.",
  },
  {
    id: "programmer",
    index: "07",
    title: "Lighting Programmer",
    icon: "TerminalSquare",
    blurb:
      "Console fluency across grandMA, Hog and Chamsys. Cues built clean, fast and show-ready under pressure.",
  },
  {
    id: "previs",
    index: "08",
    title: "Previsualisation",
    icon: "MonitorPlay",
    blurb:
      "See the show before it exists. Full 3D previs so clients approve, and crews rehearse, in the virtual room.",
  },
];

export const PORTFOLIO = [
  {
    id: "concert-mumbai",
    title: "Concert Mumbai",
    category: "Music Concert · Mumbai",
    year: "2026",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_visual-spectacle/artifacts/9aenp8ow_Concert%20Mumbai.jpeg",
    span: "lg",
  },
  {
    id: "one8-delhi",
    title: "One8 Delhi",
    category: "One8 by Virat Kohli · Delhi",
    year: "2026",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_visual-spectacle/artifacts/dja77rtp_One8Delhi.jpeg",
    span: "sm",
  },
  {
    id: "jio-blast",
    title: "Jio Blast",
    category: "Jio Blast Event",
    year: "2026",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_visual-spectacle/artifacts/ywi5kons_Jio%20Blast.jpeg",
    span: "sm",
  },
  {
    id: "antaranga",
    title: "Antaranga",
    category: "Classical Music & Dance · Bangalore",
    year: "2026",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_visual-spectacle/artifacts/nwbg34b7_Antaranga.jpeg",
    span: "lg",
  },
  {
    id: "adp-hyderabad",
    title: "ADP Studio",
    category: "ADP · Hyderabad",
    year: "2026",
    image: "https://customer-assets-gfyr7b9c.emergentagent.net/job_visual-spectacle/artifacts/x9uy8myb_IMG-20260727-WA0029.jpg.jpeg",
    span: "sm",
  },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "The Void",
    body: "We begin in absolute darkness. Nothing exists until we decide it should. Black is not empty — it is potential, waiting for a reason to be broken.",
  },
  {
    no: "02",
    title: "The Beam",
    body: "A single shaft of light directs a thousand eyes. We choreograph focus — deciding what the audience feels before they know they are feeling it.",
  },
  {
    no: "03",
    title: "The Vision",
    body: "Concept becomes concert. Every plot, rig and cue is executed with the precision of engineers and the instinct of artists. The show becomes memory.",
  },
];

export const TEAM = [
  {
    name: "Ravindra Darekar",
    role: "Founder",
    photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_visual-spectacle/artifacts/7ic0wtu6_Ravindra.jpg",
    bio: "Ravindra Darekar is a veteran of India's live entertainment industry with over two decades of experience in production, sound and technical execution. As Founder of Piranha Engineers and The Vision Studio, he has helped shape large-format concert production, working with artists including Arijit Singh. His expertise and leadership have contributed to raising standards of technical excellence across India's live concert landscape.",
  },
  {
    name: "Prathamesh Chaudhary",
    role: "Founder · Lighting Designer · Director & Programmer",
    photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_visual-spectacle/artifacts/mkbaqqzz_Prathamesh.jpeg",
    bio: "Prathamesh Chaudhary is a Lighting Designer, Director, Programmer and Show Operations professional with 10+ years of experience and 800+ productions. Recognised as India's youngest Lighting Designer across multiple seasons of Kaun Banega Crorepati, he has delivered major productions including Coldplay, Martin Garrix, Sunburn and Lollapalooza — combining creative vision, programming expertise and precise show execution.",
  },
  {
    name: "Nitesh Kadam",
    role: "Lighting Designer · Programmer & Operator",
    photo: "https://customer-assets-gfyr7b9c.emergentagent.net/job_visual-spectacle/artifacts/vsv0jw7g_Nitesh.jpeg",
    bio: "Nitesh Kadam is a Lighting Designer, Programmer and Show Operations professional with 15+ years of experience and 900+ productions across India. His expertise spans concerts, festivals, television, corporate events and touring productions. Known for combining creative lighting design with technical precision, Nitesh has worked with leading artists including Arijit Singh, Sunidhi Chauhan and Amit Trivedi.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "It was an absolute pleasure to work with Vision Studio. The light show was outstanding and looked majestic on the live.",
    name: "Siddhesh Jalgaonkar",
    org: "Laqshya Media Group",
  },
  {
    quote:
      "The show looked amazing and absolutely loved the lighting design and great programming.",
    name: "Organising Team",
    org: "One8 Launch",
  },
];

export const MARQUEE_ITEMS = [
  "Lighting Design",
  "Stage Rigging",
  "Previsualisation",
  "Concept Shows",
  "Lighting Plots",
  "Console Programming",
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);
